export class MessageCostSummary {
  pointLimit: number | null;
  usedPoints: number;

  constructor(pointLimit: number | null, usedPoints: number) {
    this.pointLimit = pointLimit;
    this.usedPoints = usedPoints;
  }

  isLimitInfinite(): boolean {
    return this.pointLimit === null;
  }

  /**
   * 使用率をパーセンテージで返す（0-100の範囲）
   * 無制限プランまたはlimit=0の場合は0を返す
   */
  calculateUsagePercentage(): number {
    if (this.isLimitInfinite() || this.pointLimit === 0) {
      return 0;
    }
    // ここまで来たらpointLimitはnullでも0でもない
    const percent = (this.usedPoints / this.pointLimit!) * 100;
    // 0-100の範囲にクランプ
    return Math.min(100, Math.max(0, percent));
  }
}
